import { render } from "./FormularioInfo.vue?vue&type=template&id=6035458a&scoped=true"
import script from "./FormularioInfo.vue?vue&type=script&lang=js"
export * from "./FormularioInfo.vue?vue&type=script&lang=js"

import "./FormularioInfo.vue?vue&type=style&index=0&id=6035458a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6035458a"]])

export default __exports__